import { render, staticRenderFns } from "./toko.vue?vue&type=template&id=74f39df4"
import script from "./toko.vue?vue&type=script&lang=js"
export * from "./toko.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports